<script>
import { useSnackbarStore } from '@/store/snackbarStore'

export default {
  name: 'SnackbarComponent',
  computed: {
    snackbar() {
      return useSnackbarStore()
    },
    snackbarProps() {
      const color = this.$vuetify.theme.current.colors[this.snackbar.color]
      const backgroundColor = /^#[\da-f]{6}$/i.test(color)
        ? `rgb(${[1, 3, 5]
            .map((offset) => {
              const channel = parseInt(color.slice(offset, offset + 2), 16)
              return channel + Math.round((255 - channel) * 0.88)
            })
            .join(', ')})`
        : this.snackbar.color
      const icons = {
        success: 'mdi-check-circle',
        warning: 'mdi-alert',
        error: 'mdi-alert-circle'
      }
      return {
        backgroundColor,
        color: `text-${this.snackbar.color}`,
        icon: icons[this.snackbar.color] || 'mdi-alert'
      }
    }
  }
}
</script>

<template>
  <v-snackbar
    v-model="snackbar.visible"
    :color="snackbarProps.backgroundColor"
    variant="flat"
    location="top right"
    :content-class="snackbarProps.color"
    :timeout="snackbar.timeout"
    :multi-line="snackbar.multiline === true"
  >
    <div class="d-flex align-center">
      <v-icon class="mr-3" :icon="snackbarProps.icon" />
      <p>{{ snackbar.text }}</p>
    </div>
  </v-snackbar>
</template>
